import {CasinoLegacyDeepLinkActionBase} from '../casino-legacy-deep-link-action-base';

export class MyAccountUploadDocumentDeeplinkAction extends CasinoLegacyDeepLinkActionBase {

  async execute(): Promise<void> {
    await this.services.messageBroker.channels.performAction.topics.uploadDocumentsFromCashier.execute({});
  }
}
